import { FilterField } from "kontrolEdge/helpers/advancedFilters";
import {
  Report,
  formatDateMonthYear,
  formatReportGroup,
  formatReportStatus,
} from "./ReportsData";

/**
 * Searchbar fields for the Reports list.
 *
 * Accessors return the **label the user reads in the cell**, not the raw wire
 * value, so what someone types in the searchbar matches what the table shows
 * ("Completed", "February, 2026"). `buildPredicate` compares
 * case-insensitively, so `status:completed` works just as well.
 *
 * There is no Type field: the page splits the list into a tab per type
 * (CTX-1192), so every row a search can reach already shares one.
 *
 * Reports has no partner/customer column gating: the page is already scoped to
 * PARTNER / GLOBAL_ADMIN and the customer is a plain column on every row.
 */
export function makeReportFields(): FilterField<Report>[] {
  return [
    {
      label: "ID",
      key: "id",
      type: "number",
      accessor: (r: Report) => r.id,
      inFreeText: true,
    },
    {
      label: "Customer Name",
      key: "customer_name",
      type: "string",
      accessor: (r: Report) => r.customer_name,
      inFreeText: true,
    },
    {
      label: "Customer ID",
      key: "customer_id",
      type: "string",
      accessor: (r: Report) => r.customer_id,
      inFreeText: true,
    },
    {
      label: "Date",
      key: "date",
      type: "string",
      accessor: (r: Report) => formatDateMonthYear(r.date),
      inFreeText: true,
    },
    {
      label: "Purchase Order",
      key: "reportGroupLabel",
      type: "string",
      accessor: (r: Report) => formatReportGroup(r),
      inFreeText: true,
    },
    {
      label: "Status",
      key: "status",
      type: "string",
      accessor: (r: Report) => formatReportStatus(r.status).label,
      inFreeText: true,
    },
  ];
}
